import React from 'react';
import { Box, Typography } from '@mui/material';

function MainTab(props) {
  const activeColor = '#1E88E5';
  const inactiveColor = '#64748B';

  return (
    <Box
      onClick={props.onClick}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        cursor: 'pointer',
        px: 2.5,
        position: 'relative',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        backgroundColor: props.active ? 'rgba(30, 136, 229, 0.06)' : 'transparent',
        borderRadius: '12px',
        mx: 0.5,
        '&:hover': {
          backgroundColor: props.active ? 'rgba(30, 136, 229, 0.08)' : 'rgba(0, 0, 0, 0.03)',
          transform: 'translateY(-1px)',
        },
        // Animated Bottom Indicator
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '8px',
          left: '20%',
          right: '20%',
          height: '3px',
          backgroundColor: activeColor,
          borderRadius: '2px',
          transition: 'all 0.3s ease',
          opacity: props.active ? 1 : 0,
          transform: props.active ? 'scaleX(1)' : 'scaleX(0.5)',
        }
      }}
    >
      <Box
        sx={{
          mr: 1.2,
          display: 'flex',
          alignItems: 'center',
          color: props.active ? activeColor : inactiveColor,
          transition: 'all 0.3s ease',
          transform: props.active ? 'scale(1.1)' : 'scale(1)',
        }}
      >
        <i className={`iconfont ${props.icon}`} style={{ fontSize: '1.1rem' }}></i>
      </Box>
      
      <Typography
        variant="body2"
        sx={{
          fontWeight: props.active ? 800 : 600,
          color: props.active ? activeColor : inactiveColor,
          fontSize: '0.9rem',
          letterSpacing: '0.01em',
          transition: 'all 0.3s ease',
        }}
      >
        {props.text}
      </Typography>
    </Box>
  )
}

export default MainTab
